<template>

  <div id="app">
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo: {
    meta: [
      {name: 'robots', content: 'noindex'}
    ]
  },
  methods: {}
}
</script>

<style lang="scss">
  @import "assets/scss/theme";
</style>



// WEBPACK FOOTER //
// App.vue?04b267b5